import { render, staticRenderFns } from "./RecommendationList.vue?vue&type=template&id=02d2be01&"
import script from "./RecommendationList.vue?vue&type=script&lang=ts&"
export * from "./RecommendationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports